import { useEffect, useState, useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import ArrowBottom from "../../assets/icons/ArrowBottom";
import { useSelector } from "react-redux";
import { allLotsSelector } from "../../redux/liveAuction.slice";

export const DropdownLotGo = ({ styleDropdown, type = "time", isMobile = false }) => {
  const { push } = useHistory();
  const allLotsFromRedux = useSelector(allLotsSelector);
  const [dataUnit, setDataUnit] = useState([]);
  const dropdownMenuRef = useRef(null);

  const handleClickItem = (unit) => {
    // Get auction ID from URL params since it's not in the unit data
    const currentPath = window.location.pathname;
    const auctionIdMatch = currentPath.match(/\/(time|close)-bid-auction\/(\d+)/);
    const auctionId = auctionIdMatch ? auctionIdMatch[2] : null;

    if (auctionId) {
      push(`/${type === "time" ? "time" : "close"}-bid-auction/${auctionId}/${unit?.id}`);
      window.location.reload();
    }
  };

  // Use Redux data for lot list
  useEffect(() => {
    if (allLotsFromRedux && allLotsFromRedux.length > 0) {
      // Filter out units with status that indicates cancelled (if applicable)
      // For now, show all units since the data structure doesn't have is_cancel_auction
      const filteredData = allLotsFromRedux.filter((unit) => unit.id && unit.lot_number);
      setDataUnit(filteredData);
    } else {
      setDataUnit([]);
    }
  }, [allLotsFromRedux]);

  return (
    <Dropdown align="end">
      <Dropdown.Toggle id="dropdown-basic" variant="light" className="disable-caret  cursor-pointer bg-header">
        {isMobile ? (
          <p className="px-3 mb-0 me-1">
            {type === "time" ? "Lot Time Bid" : "Lot Close Bid"}
            <ArrowBottom />
          </p>
        ) : (
          <div className="py-2 d-flex align-items-center">
            <p className="mb-0 text-secondary fw-bold hover-primary">
              {type === "time" ? "Lot Time Bid" : "Lot Close Bid"}
            </p>
            <ArrowBottom />
          </div>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu
        style={{
          ...styleDropdown,
          maxHeight: dataUnit?.length <= 5 ? "120px" : dataUnit?.length <= 7 ? "150px" : "200px",
          overflowY: "auto",
          overflowX: "hidden",
          scrollbarWidth: "thin",
        }}
        ref={dropdownMenuRef}
      >
        {dataUnit && dataUnit.length > 0 ? (
          dataUnit.map((unit, index) => {
            return (
              <Dropdown.ItemText key={index}>
                <div className="dropdown-item-header fw-normal" onClick={() => handleClickItem(unit)}>
                  Lot {unit?.lot_number ? unit.lot_number : "-"}
                </div>
              </Dropdown.ItemText>
            );
          })
        ) : (
          <Dropdown.ItemText>
            <div className="dropdown-item-header fw-normal text-muted">Tidak ada lot tersedia</div>
          </Dropdown.ItemText>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
